import {IntlShape} from "react-intl";
import {Connector, TopicDescription, TopicDescriptionInfo} from "./APITypes";

/**
 * Generates the internationalized texts for enum-properties of topics
 * @function
 * @param intl - the intl-Context as provided by useIntl()
 * @param description - the topic description (info) or connector for which to generate text
 * @param field - the property to generate
 */
export const generateTopicDescriptionText = (
  intl: IntlShape,
  description: TopicDescription | TopicDescriptionInfo | Connector,
  field: "HEALTH" | "METHOD",
) => {
  const transferType =
    "transfer_type" in description
      ? description.transfer_type
      : description.transfer.transfer_type;
  const direction =
    "direction" in description
      ? description.direction
      : description.transfer.direction;
  switch (field) {
    case "HEALTH":
      return intl.formatMessage({
        id: "topicDescriptionConnector.health." + description.health,
      });
    case "METHOD":
      return intl.formatMessage({
        id:
          "topicDescriptionConnector.method." +
          (transferType === "GRAPHQL"
            ? "graphql"
            : transferType === "FILE_UPLOAD"
              ? "file_upload"
              : transferType === "MULTI_FILE_UPLOAD"
                ? "multi_file_upload"
                : transferType === "MQTT"
                  ? "mqtt"
                  : direction === "PULL"
                    ? "rest_pull"
                    : "rest_push"),
      });
  }
};
